import container from '@/container';
import { StringsServiceContract, CONTRACTS } from '@/core/contracts';

function localize(notLocalizedInput: string, key?: string): string {
    if (key) {
        notLocalizedInput = `${key}_${notLocalizedInput}`;
    }

    return container
        .get<StringsServiceContract>(CONTRACTS.StringsService)
        .get(notLocalizedInput);
}

export default localize;
